export default {
    state: {
        all: [],
        filtered: [],
        categories: [],
    },
    actions: {
        loadReports({ commit }) {
            axios.get('/api/reports/categories').then((response) => {
                commit('updateCategories', { type: 'categories', items: response.data })
            })
        }
    },
    mutations: {
        updateCategories(state, data) {
            state[data.type] = data.items;
        },
        updateReports(state, data) {
            state[data.type] = data.items;
        },
    }
};